module.exports = __webpack_public_path__ + "static/img/4_1_0.f909752.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/department/4_1_0.png
// module id = bzUL
// module chunks = 1